import Flickity from 'flickity';
import IMGFlickity from 'flickity-imagesloaded';
import BGLazyLoadFlickity from 'flickity-bg-lazyload';


// flickering fix for ie
const focus = Flickity.prototype.focus;
Flickity.prototype.focus = function() {
  // use non-standard setActive for IE11. #651
  if ( this.element.setActive  ) {
    this.element.setActive();
    return;
  }
  // use default
  focus.apply( this, arguments );
};

// flickity height fix
Flickity.prototype._createResizeClass = function() {
    setTimeout(() => {
        this.element.classList.add('flickity-resize');
    });
};
Flickity.createMethods.push('_createResizeClass');

const resize = Flickity.prototype.resize;
Flickity.prototype.resize = function() {
    this.element.classList.remove('flickity-resize');
    resize.call( this );
    this.element.classList.add('flickity-resize');
};

/**
 * *******************************
 * testimonial carousel
 * *******************************
*/
const testimonialCarousels = document.querySelectorAll('.testimonial-carousel-container');
let tFlickity = null;
const createTCarousel = function(carouselContainer) {
    const tCarousel = carouselContainer.querySelector('.testimonial-carousel');
    const tCarouselStatus = carouselContainer.querySelector('.testimonial-carousel-status');
    tFlickity = new Flickity(tCarousel, {
        wrapAround: true,
        cellAlign: 'left',
        contain: true,
        pageDots: true,
        prevNextButtons: true,
        on: {
            select: function (index) {
                if (tCarouselStatus) {
                    tCarouselStatus.textContent = `${index + 1} of ${this.slides.length}`;
                }
            },
        },
    });
}
testimonialCarousels.forEach(elem => {
    createTCarousel(elem);
});

// resolve the font loading issue, which causes the different height
document.fonts.ready.then(function () {
    if (tFlickity) {
        tFlickity.resize();
    }
});

/**
 * *******************************
 * banner carousel
 * *******************************
*/
const bannerCarousels = document.querySelectorAll('.banner-carousel-container');
const createBCarousel = function(carouselContainer) {
    const bCarousel = carouselContainer.querySelector('.banner-carousel');
    new Flickity(bCarousel, {
        wrapAround: true,
        cellAlign: 'left',
        contain: true,
        pageDots: true,
        prevNextButtons: true,
        bgLazyLoad: 1,
    });
}
bannerCarousels.forEach(elem => {
    createBCarousel(elem);
});

/**
 * *******************************
 * gallery carousel
 * *******************************
*/
const galleryCarousels = document.querySelectorAll('.gallery-carousel-container');

const createGCarousel = function(carouselContainer) {
    const gCarousel = carouselContainer.querySelector('.gallery-carousel');
    const gCarouselStatus = carouselContainer.querySelector('.gallery-carousel-status');
    new BGLazyLoadFlickity(gCarousel, {
        wrapAround: true,
        cellAlign: 'left',
        contain: true,
        pageDots: false,
        prevNextButtons: true,
        bgLazyLoad: 1,
        on: {
            select: function (index) {
                if (gCarouselStatus) {
                    if (gCarousel.classList.contains('media')) {
                        gCarouselStatus.textContent = `Photo ${index + 1} of ${this.slides.length}`;
                    } else {
                        gCarouselStatus.innerHTML = `<strong>${index + 1}/${this.slides.length}</strong>${this.selectedElement.querySelector('.sr-only').textContent}`;
                    }
                }
            },
        },
    });
}

galleryCarousels.forEach(elem => {
    createGCarousel(elem);
});

/**
 * *******************************
 * article carousel
 * *******************************
*/
const articleCarousels = document.querySelectorAll('.article-carousel-container');

const createACarousel = function(carouselContainer) {
    const aCarousel = carouselContainer.querySelector('.article-carousel');
    new Flickity(aCarousel, {
        wrapAround: true,
        cellAlign: 'left',
        contain: true,
        pageDots: false,
        prevNextButtons: true,
        watchCSS: true,
    });
}

articleCarousels.forEach(elem => {
    createACarousel(elem);
});

/**
 * *******************************
 * pagelink carousel
 * *******************************
*/
const pagelinkCarousels = document.querySelectorAll('.pagelink-carousel-container');

const createPCarousel = function(carouselContainer) {
    const pCarousel = carouselContainer.querySelector('.pagelink-carousel');
    new Flickity(pCarousel, {
        wrapAround: true,
        cellAlign: 'left',
        contain: true,
        pageDots: false,
        prevNextButtons: true,
        watchCSS: true,
    });
}

pagelinkCarousels.forEach(elem => {
    createPCarousel(elem);
});

/**
 * *******************************
 * logos carousel
 * *******************************
*/
const logoCarousels = document.querySelectorAll('.logos-carousel-container');

const createLCarousel = function(carouselContainer) {
    const lCarousel = carouselContainer.querySelector('.logos');
    new Flickity(lCarousel, {
        wrapAround: true,
        cellAlign: "left",
        contain: true,
        pageDots: false,
        prevNextButtons: false,
        watchCSS: true,
        imagesLoaded: true
    });
}

logoCarousels.forEach(elem => {
    createLCarousel(elem);
});